import { createContext } from 'react';

// Heading Sizes
const SIZES = [
    'sm',
    'md',
    'lg'
];
const VALID_HEADING_SIZES = [
    ...SIZES
];
// Heading Types
const TYPES = [
    'page',
    'section',
    'title'
];
const VALID_HEADING_TYPES = [
    ...TYPES
];
/**
 * Heading Context.
 */ const HeadingContext = /*#__PURE__*/ createContext(null);

export { HeadingContext, VALID_HEADING_SIZES, VALID_HEADING_TYPES };
//# sourceMappingURL=context.es.js.map
